// circular publication route
export const circularPublication = 'admission/circular-publication'
export const circularPublicationList = circularPublication + '/list'
export const circularPublicationStore = circularPublication + '/store'
export const circularPublicationUpdate = circularPublication + '/update'
export const circularPublicationStatus = circularPublication + '/toggle-status'

// online admission application routes
export const onlineAdmissionList = 'admission/online-admission-application/list'
export const onlineAdmissionStore = 'admission/online-admission-application/store'
export const onlineAdmissionUpdate = 'admission/online-admission-application/update'

// meeting management
export const meetingManagementListApi = 'admission/meeting-management/list'
export const meetingManagementStoreApi = 'admission/meeting-management/store'
export const meetingManagementUpdateApi = 'admission/meeting-management/update'
export const onlineAdmissionDataApi = 'admission/meeting-management/student-application'

// assign to school
export const assignToSchoolListApi = 'admission/assign-to-school/list'
export const assignToSchoolStoreApi = 'admission/assign-to-school/store'
export const childDataForCourtApi = 'legal-institute-management/assign-to-school/info-by-child-number'
export const assignToApproveStoreApi = 'admission/assign-to-school/approve-store'
export const assignToRejectStoreApi = 'admission/assign-to-school/reject-store'
export const getResidentDetail = 'admission/assign-to-school/get-resident'
export const assignToSchoolUpdateApi = 'admission/assign-to-school/update'

// dismissed-children
export const dismissedChildrenListApi = 'admission/dismissed-children/list'
export const dismissedChildrenStoreApi = 'admission/dismissed-children/store'
// export const childDataForCourtApi = 'legal-institute-management/dismissed-children/info-by-child-number'
export const getDismissedChildren = 'admission/dismissed-children/get-resident'
export const dismissedChildrenUpdateApi = 'admission/dismissed-children/update'

// released-children
export const releasedChildrenListApi = 'admission/released-children/list'
export const releasedChildrenStoreApi = 'admission/released-children/store'
export const getReleasedChildren = 'admission/released-children/get-resident'
export const releasedChildrenUpdateApi = 'admission/released-children/update'

// school-transfer
export const schoolTrnsferListApi = 'admission/school-transfer/list'
export const schoolTrnsferStoreApi = 'admission/school-transfer/store'
export const schoolTrnsferCourtApi = 'legal-institute-management/school-transfer/info-by-child-number'
export const assign2ToApproveStoreApi = 'admission/school-transfer/approve-store'
export const assign2ToRejectStoreApi = 'admission/school-transfer/reject-store'
export const getResidentDetail2 = 'admission/school-transfer/get-resident'
export const schoolTrnsferUpdateApi = 'admission/school-transfer/update'

// assign to rehabilitation
export const assignToRehabilitationStoreApi = 'admission/assign-to-rehabilitation/store'
export const removeFromRehabilitationApi = 'admission/assign-to-rehabilitation/remove'
